<div id="floating-elements fade-in">
  <div class="floating cube further"></div>
  <div class="floating cube far"></div>
  <div class="floating cube close"></div>
  <div class="floating coin"></div>
  <div class="floating www"></div>
</div>
